import { Component } from "react";
import { text } from "@quickpoint.me/shared";
import { withTour } from "@reactour/tour";
import { useStartTour } from "../../../../hooks/useStartTour";
import { type TourSection, tourSectionStartStep } from "./sections";

/** Accessibility is the product's key selling point — offer the dedicated
 *  Accessibility Tour right from the Full Tour's contents page. */
function AccessibilityTourJump() {
	const startTour = useStartTour();
	return (
		<div style={{ marginTop: "0.9rem" }}>
			<div>{text.tourSteps.contentsAccessibilityTour}</div>
			<button
				className="tour-step-links"
				onClick={() => startTour("a11y")}
				type="button"
			>
				{text.tourSteps.contentsAccessibilityTourButton}
			</button>
		</div>
	);
}

//  [...intro, ...basics(hostId), ...stories, ...images(hostId), ...split, ...grid];

class Contents extends Component {
	render() {
		const handleClick = (location: TourSection) => {
			// @ts-expect-error
			this.props.setCurrentStep(tourSectionStartStep(location));
		};
		return (
			<>
				<div>
					{text.tourSteps.contentsInstructions}
				</div>
				<button
					className="tour-step-links"
					onClick={() => handleClick("basics")}
					type="button"
				>
					{text.tourSteps.contentsGettingStarted}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("stories")}
					type="button"
				>
					{text.tourSteps.contentsStories}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("formatting")}
					type="button"
				>
					{text.tourSteps.contentsFormattingText}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("links")}
					type="button"
				>
					{text.tourSteps.contentsLinksAndBacklinks}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("images")}
					type="button"
				>
					{text.tourSteps.contentsAddingImages}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("charts")}
					type="button"
				>
					{text.tourSteps.contentsCharts}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("publishing")}
					type="button"
				>
					{text.tourSteps.contentsSharingAndPublishing}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("split")}
					type="button"
				>
					{text.tourSteps.contentsMasteringLayouts}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("fx")}
					type="button"
				>
					{text.tourSteps.contentsMasteringFx}
				</button>
				<AccessibilityTourJump />
			</>
		);
	}
}

export default withTour(Contents);
